module.exports = __webpack_public_path__ + "static/media/Cars.66010bd0.png";